import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ServicemenLeads from "../components/VendorAppointements";

const MyAppointmentsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='My Appointments' />

                <ServicemenLeads />

            </MasterLayout>
        </>
    );
};

export default MyAppointmentsPage;
